// extracted by mini-css-extract-plugin
export var banner = "_1m-0";
export var icon = "_1m-1";
export var message = "_1m-2";